import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/hash-bold.vue
var o = {
	name: "DtIconHashBold",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--hash-bold"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Hash Bold",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M4.068 1.396a.938.938 0 0 1 1.864.207l-.218 1.96h1.114l.24-2.167a.938.938 0 0 1 1.864.207l-.218 1.96H10a.937.937 0 1 1 0 1.874H8.506L8.38 6.562H10a.937.937 0 1 1 0 1.875H8.172l-.24 2.167a.937.937 0 1 1-1.864-.208l.218-1.959H5.172l-.24 2.167a.937.937 0 1 1-1.864-.208l.218-1.959H2a.937.937 0 1 1 0-1.875h1.494l.125-1.125H2a.937.937 0 1 1 0-1.875h1.828l.24-2.166ZM4.715 4.3a.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174Zm2.747.226a.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174.501.501 0 0 1-.253.226ZM7.382 7.3a.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174Zm-2.844.174a.5.5 0 0 1-.156-.174.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226Zm.968-2.037L5.38 6.562h1.113l.125-1.125H5.506Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=hash-bold.js.map